import { QRCodeSVG } from "qrcode.react"
import { cn } from "~/common/cn"
import { getMetaContentMaybe } from "~/common/get-meta-content"
import { AppText } from "~/ui/app-text"
import { downloadPath } from "~/common/paths"

type DownloadQrProps = {
  className?: string
  captionClassName?: string
  hideCaption?: boolean
}

export const DownloadQr = ({
  className,
  captionClassName,
  hideCaption,
}: DownloadQrProps): JSX.Element | null => {
  if (getMetaContentMaybe("show-download-qr") !== "true") return null

  return (
    <div className={cn("flex flex-col items-center gap-3 pb-8 pt-6", className)}>
      <div className="rounded-[16px] bg-base-white p-3">
        <QRCodeSVG
          value={`${window.location.origin}${downloadPath({})}`}
          size={96}
          aria-label="QR code linking to the app download page"
          role="img"
        />
      </div>
      {!hideCaption && (
        <AppText
          variant="body3-medium"
          className={cn("text-base-white opacity-50 md:text-15 md:tracking-n1-5", captionClassName)}
        >
          Scan to download the app
        </AppText>
      )}
    </div>
  )
}
